// The Vue build version to load with the `import` command
// (runtime-only or standalone) has been set in webpack.base.conf with an alias.
import 'babel-polyfill';

/**
 * Styling
 */
import 'font-awesome/css/font-awesome.css';

import '@/assets/style/style.scss';
import '@/assets/style/element-variables.scss';
import 'vue-croppa/dist/vue-croppa.css';

/**
 * Official vue libraries
 */
import Vue from 'vue';
import VueRouter from 'vue-router';
import Vuex from 'vuex';

/**
 * Third party libraries
 */
import ElementUI from 'element-ui';
import locale from 'element-ui/lib/locale/lang/en';
import VueMoment from 'vue-moment';
import { hasSubscription } from '@jumpn/utils-graphql';
import { ApolloClient } from 'apollo-client';
import { HttpLink } from 'apollo-link-http';
import { setContext } from 'apollo-link-context';
import { createLink } from 'apollo-absinthe-upload-link';
import { InMemoryCache } from 'apollo-cache-inmemory';
import { split } from 'apollo-link';
import VueApollo from 'vue-apollo';
import Croppa from 'vue-croppa';
import VueAnalytics from 'vue-analytics';
import * as AbsintheSocket from '@absinthe/socket';
import { createAbsintheSocketLink } from '@absinthe/socket-apollo-link';
import { Socket as PhoenixSocket } from 'phoenix';
import * as Sentry from '@sentry/browser';
import { Vue as VueIntegration } from '@sentry/integrations';
import VueCookies from 'vue-cookies';

/**
 * App
 */
import App from './App';
import router from './router';
import store from './store';

/**
 * Google analytics
 */
const isProd = process.env.NODE_ENV === 'production';

Vue.use(VueAnalytics, {
  id: process.env.GOOGLE_ANALYTICS_ID,
  router,
  autoTracking: {
    screenview: true,
    exception: true,
  },
  debug: {
    enabled: !isProd,
    sendHitTask: isProd,
  },
});

/**
 * Apollo
 */
const middlewareLink = setContext(() => ({
  headers: {
    authorization: `JWT ${localStorage.getItem('token')}`,
  },
}));

const v1HttpLink = new HttpLink({ uri: process.env.GRAPHQL_COLONY_V1 });

// Create the apollo clients
const v1ApolloClient = new ApolloClient({
  link: middlewareLink.concat(v1HttpLink),
  cache: new InMemoryCache(),
  connectToDevTools: true,
});

const v2HttpLink = createLink({ uri: process.env.GRAPHQL_COLONY_V2 });
// const uploadLink = createUploadLink({ uri: process.env.GRAPHQL_COLONY_V2 });

window.phoenixSocket = new PhoenixSocket(process.env.WS_COLONY_V2, {
  reconnect: true,
  params: { token: localStorage.getItem('token') },
});

const absintheSocketLink = createAbsintheSocketLink(AbsintheSocket.create(window.phoenixSocket));

const v2LinkWithSubscriptions = split(
  operation => hasSubscription(operation.query),
  absintheSocketLink,
  middlewareLink.concat(v2HttpLink),
);

const v2ApolloClient = new ApolloClient({
  link: middlewareLink.concat(v2LinkWithSubscriptions),
  cache: new InMemoryCache({ addTypename: false }),
  connectToDevTools: true,
});

const apolloProvider = new VueApollo({
  clients: {
    apiv1: v1ApolloClient,
    apiv2: v2ApolloClient,
  },
  defaultClient: v1ApolloClient,
});

/**
 * Application wide components
 */
Vue.use(VueRouter);
Vue.use(Vuex);
Vue.use(ElementUI, { locale });
Vue.use(VueMoment);
Vue.use(VueApollo);
Vue.use(Croppa);
Vue.use(VueCookies);

/**
 * Custom Vue Config
 * */
Vue.config.productionTip = false;
Vue.config.keyCodes.comma = 188;

/**
 * Sentry Configuration
 * */

if (isProd === true) {
  Sentry.init({
    dsn: process.env.SENTRY_DSN,
    environment: process.env.SENTRY_ENV,
    integrations: [new VueIntegration({ Vue, attachProps: true })],
  });
}

/* eslint-disable no-new */
new Vue({
  el: '#app',
  router,
  store,
  template: '<App/>',
  components: { App },
  apolloProvider,
});



// WEBPACK FOOTER //
// ./src/main.js